<template>
  <b-container class="container-xl vali-hollow-logo text-left">
    <h1 class="mt-4">
      <strong>Pályázati útmutatók</strong>
    </h1>
    <h3 class="mt-3">
      Töltse le a pályázati útmutatókat
    </h3>
    <div class="row mt-5">
      <competition-guide-download
        v-for="(guide, index) in guides"
        v-bind:key="`${guide}.text-${index}`"
        :text="guide.text"
        :link="guide.link"
      ></competition-guide-download>
    </div>
    <h3 class="mt-5">
      Tekintse meg az elszámolható képzések listáját
    </h3>
    <div class="row mt-3">
      <competition-guide-download
        v-for="(course, index) in courses"
        v-bind:key="`${guide}.text-${index}`"
        :text="course.text"
        :link="course.link"
        :rightArrow="true"
      ></competition-guide-download>
    </div>
  </b-container>
</template>

<script>
import CompetitionGuideDownload from './CompetitionGuideDownload.vue'
export default {
  data: function() {
    return {
      guides: [
        {
          text:
            'GINOP-1.2.14-20 és VEKOP 1.2.7-20 pályázatok eredményességi méréséhez igénybe vehető szolgáltatások jegyzéke',
          link: '../static/GINOP_1214-VEKOP_127_eredményességi_mérés_képzések.pdf'
        },
        {
          text: 'Pályázói kézikönyv a korszerű vállalati technológiai megoldások alkalmazásához – GINOP Plusz 1.2.3-21',
          link:
            'https://vali.hu/static/Palyazoi_kezikonyv_a_korszeru_vallalati_technologiai_megoldasok_alkalmazasahoz_%E2%80%93_GINOP_Plusz_1.2.3-21.pdf'
        },
        {
          text: 'Eredményességi mérés útmutató – a GINOP Plusz 1.2.3-21 felhívás 6. számú szakmai melléklete',
          link:
            'https://vali.hu/static/Eredmenyessegi_meres_utmutato_%E2%80%93_a_GINOP_Plusz_1.2.3-21_felhivas_6_szamu_szakmai_melleklete.pdf'
        },
        {
          text: 'Pályázói kézikönyv az MGFÜ eredményességi méréshez kapcsolódó szolgáltatásairól',
          link: '../static/TVT_Palyazoi_kezikonyv_MGFU_eredmenyessegi_meres.pdf'
        },
        {
          text: 'Pályázói kézikönyv a korszerű vállalati technológiai megoldások alkalmazásához',
          link: '../static/TVT_Palyazoi_kezikonyv_korszeru_vallalati_tech_megoldasok.pdf'
        },
        {
          text:
            'A GINOP-1.2.8-20 és VEKOP 1.2.6-20 pályázatok eredményességi méréséhez igénybe vehető szolgáltatások jegyzéke',
          link: '../static/GINOP_128_szolgaltatas_jegyzek_2022 jan.pdf'
        },
        {
          text: 'Eredményességi mérés útmutató – a GINOP Plusz 1.3.1-21 felhívás 7. számú szakmai melléklete',
          link:
            '../static/Eredmenyessegi_meres_utmutato_–_a_GINOP_Plusz_1.3.1-21_felhivas_7_szamu_szakmai_melleklete.pdf'
        },
        {
          text: 'Eredményességi mérés útmutató – a GINOP Plusz 1.2.1-21 felhívás 8. számú szakmai melléklete',
          link:
            '../static/Eredmenyessegi_meres_utmutato_–_a_GINOP_Plusz_1.2.1-21_felhivas_8_szamu_szakmai_melleklete.pdf'
        },
        {
          text: 'Eredményességi mérés útmutató - GINOP 1.2.15-21 szolgáltatás jegyzék',
          link: '../static/Eredmenyessegi_meres_utmutato_–_GINOP_1.2.15-21_szolgaltatas_jegyzek.pdf'
        }
      ],
      courses: [
        {
          text: 'GINOP 1.2.8-20 és VEKOP 1.2.6-20 keretében elszámolható képzések',
          link: 'https://vali.ifka.hu/courses'
        }
      ]
    }
  },
  components: { CompetitionGuideDownload },
  name: 'CompetitionGuide'
}
</script>
<style scoped>
.vali-hollow-logo {
  position: relative;
  overflow: hidden;
}

.vali-hollow-logo:before {
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.2;
  background-image: url('../../assets/img/logo/vekonyvali_hollow.svg');
  background-repeat: no-repeat;
  background-position: 100% 0;
  background-size: 262px;
}
</style>
